// Saldo de un cambio de inscripción a otro taller: lo pagado menos el precio del
// cupo nuevo. Solo lo ve la administración; no se cobra ni se devuelve solo.

const pesos = (n) => `$${Math.abs(n || 0).toLocaleString('es-CL')}`;

export const SALDO = {
  a_favor:        { label: 'Saldo a favor del usuario',   color: 'green',   cls: 'bg-green-50 text-green-700' },
  en_contra:      { label: 'Saldo en contra del usuario', color: 'red',     cls: 'bg-red-50 text-red-700' },
  sin_diferencia: { label: 'Sin diferencia de valor',     color: 'default', cls: 'bg-gray-100 text-gray-600' },
};

export const textoSaldo = ({ saldo, sentido }) =>
  sentido === 'sin_diferencia' ? SALDO.sin_diferencia.label : `${SALDO[sentido]?.label}: ${pesos(saldo)}`;

export { pesos };
